import React from 'react';
import styled from 'styled-components';

import { mq } from '~/lib/mq';

import { angleDown } from '~/App/helpers/icons';
import { Spinner } from '~/App/shared/components/Elements';
import { IDeceasedContact } from '~/types/IDeceasedContact';
import { PersonNotFound } from './PersonNotFound';
import { Option } from './Option';

const Wrapper = styled.div`
  padding: 1rem 1.25rem;
  font-size: 1.125rem;

  ${mq('<small')`
    font-size: 1rem;
  `}
`;

const LoadMoreButton = styled.button`
  color: ${({ theme }) => theme.colors.darkBlue};
  margin: 0;
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  padding: 0.5rem 1rem;

  ${mq('>small')`
    font-size: 1.125rem;
  `};

  &:hover {
    color: ${({ theme }) => theme.colors.hoverBlue};
  }

  :after {
    ${angleDown};
    margin-left: 0.25rem;
    top: 1px;
  }
`;

const StyledSpinner = styled(Spinner)`
  height: 1rem;
  width: 1rem;
`;

interface Props {
  loading: boolean;
  data: IDeceasedContact[];
  onSelect: (selected: IDeceasedContact | null) => void;
  loadMore: (() => void) | null;
  openModal: () => void;
  closeMenu: () => void;
  id: string;
  value: IDeceasedContact | null;
}

export const Select = (props: Props) => {
  const {
    loading,
    data = [],
    onSelect,
    loadMore,
    openModal,
    closeMenu,
    id,
    value
  } = props;

  if (data.length < 1) {
    if (loading) {
      return (
        <Wrapper role="listbox" id={id}>
          Söker...
        </Wrapper>
      );
    }

    return (
      <>
        <Wrapper role="listbox" id={id}>
          Inga resultat
        </Wrapper>
        <PersonNotFound
          openModal={() => {
            closeMenu();
            openModal();
          }}
        />
      </>
    );
  }

  return (
    <>
      <div role="listbox" id={id}>
        {data.map((item) => {
          const isSelected = value === item;

          return (
            <Option
              key={item.id}
              data={item}
              selectOption={onSelect}
              selected={isSelected}
            />
          );
        })}
      </div>
      {loading && (
        <Wrapper>
          <StyledSpinner size="1rem" />
        </Wrapper>
      )}
      {loadMore && (
        <LoadMoreButton
          type="button"
          onClick={() => {
            const listbox = document.getElementById(id);
            const optionButton = listbox?.lastElementChild as
              | HTMLButtonElement
              | undefined;

            if (optionButton) {
              optionButton.focus();
            }
            loadMore();
          }}
        >
          Visa fler
        </LoadMoreButton>
      )}
      <PersonNotFound
        openModal={() => {
          closeMenu();
          openModal();
        }}
      />
    </>
  );
};
